import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { TenantHeadManager } from "./Components/TenantHeadManager/TenantHeadManager";
import "./App.css";
import WhatsAppButton from "./Components/WhatsAppButton/WhatsAppButton";
import CookieConsentBanner from "./Components/CookieConsentBanner/CookieConsentBanner";

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const isAdminOrOperator =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/operador");

  return (
    <div>
      <TenantHeadManager />
      <Outlet key={location.pathname} />
      {!isAdminOrOperator && <WhatsAppButton />}
      <CookieConsentBanner />
    </div>
  );
};

export default App;
